<table class="table content-table">
  <thead>
  <tr>
    <th>{{ 'lang.globals.channel' | translate }} / {{ 'lang.globals.screen' | translate }}</th>
    <th>{{ 'lang.globals.device' | translate }}</th>
    <th>{{ 'lang.globals.resolution' | translate }}</th>
    <th>{{ 'lang.globals.image' | translate }}</th>
    <th>{{ 'lang.globals.video' | translate }}</th>
    <th>{{ 'lang.globals.html' | translate }}</th>
  </tr>
  </thead>
  <tbody>
  <tr *ngFor="let ele of sublistItems">
    <td>
      <sb-comp-image-name-wrapper [image]="ele?.channel?.logo?.url">
        <span firstLine>{{ ele?.channel?.name }}</span>
        <span secondLine>{{ ele?.screen?.name }}</span>
      </sb-comp-image-name-wrapper>
    </td>
    <td>
      <sb-comp-name-wrapper>
        <span firstLine>ID: {{ ele?.device?.id ?? '-' }}</span>
        <span secondLine>{{ 'lang.globals.identifier' |translate }}: {{ ele?.device?.identifier ?? '-' }}</span>
        <span thirdLine>Name: {{ ele?.device?.name ?? '-' }}</span>
      </sb-comp-name-wrapper>
    </td>
    <td>
      {{ ele?.marker?.resolution?.id }}
    </td>
    <td>
      <sb-icon *ngIf="ele?.marker?.image" class="green" icon="success"></sb-icon>
      <sb-icon *ngIf="!ele?.marker?.image" class="red" icon="error"></sb-icon>
    </td>
    <td>
      <sb-icon *ngIf="ele?.marker?.video" class="green" icon="success"></sb-icon>
      <sb-icon *ngIf="!ele?.marker?.video" class="red" icon="error"></sb-icon>
    </td>
    <td>
      <sb-icon *ngIf="ele?.marker?.html" class="green" icon="success"></sb-icon>
      <sb-icon *ngIf="!ele?.marker?.html" class="red" icon="error"></sb-icon>
    </td>
  </tr>
  </tbody>
</table>
<div sb-pagination *ngIf="paginationInitialized" [collectionSize]="collectionSize" [(page)]="page" [sizes]="sizes"
     (pageChange)="pageChange($event)" [maxSize]="maxSize" [boundaryLinks]="boundaryLinks"
     (pageSizeChange)="setMaxSize($event)">
  {{ paginationString }}
</div>
